var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.layout,_vm._b({tag:"component"},'component',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }